import { inject, Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FilterSelectItem } from '../../../components/checkbox-facette/checkbox-liste/filterSelectItem';
import { AggregationKey } from '../../../model/aggregations';
import { orderedDauerBezeichnung } from '../../../model/dauer';
import {
  DauerGruppe,
  dauerGruppenUteAngebote,
  dauerGruppenWeiterbildungsangebote
} from '../../../model/dauer-gruppen';
import { BildungsbereichService } from '../../state/bildungsbereich.service';
import { FacettenService, FacetteOption } from '../facetten.service';
import { DauerUrlService } from './dauerurl.service';

@Injectable({ providedIn: 'root' })
export class DauerService extends FacettenService {
  private readonly bildungsbereichService = inject(BildungsbereichService);

  constructor() {
    const dauerUrlService = inject(DauerUrlService);

    super(dauerUrlService, AggregationKey.Dauer, orderedDauerBezeichnung);
  }

  public override getSelectItems$(): Observable<FilterSelectItem[]> {
    return combineLatest([
      this.getFacetteOptions$(),
      this.facettenUrlService.selectedOptionIds$,
      this.bildungsbereichService.isUte$
    ]).pipe(
      map(([facetteOptions, selectedIds, isUte]) => {
        const dauerGruppen = isUte ? dauerGruppenUteAngebote : dauerGruppenWeiterbildungsangebote;
        return this.buildFilterSelectItem(dauerGruppen, facetteOptions, selectedIds);
      })
    );
  }

  private buildFilterSelectItem(
    dauerGruppen: DauerGruppe[],
    facetteOptions: FacetteOption[],
    selectedIds: string[]
  ) {
    return dauerGruppen.map(({ ids, beschreibung }) => {
      const anzahl = facetteOptions
        .filter(({ id }) => ids.includes(id))
        .reduce((acc, { id }) => {
          const treffer = facetteOptions.find((option) => option.id === id)?.anzahl ?? 0;
          return acc + treffer;
        }, 0);
      const isSelected = selectedIds.join(',') === ids.join(',');
      return {
        key: ids.join(','),
        ariaLabel: beschreibung,
        treffer: anzahl,
        label: beschreibung,
        selected: isSelected,
        active: anzahl > 0
      };
    });
  }
}
